module.exports = __webpack_public_path__ + "assets/vehicle-black.529801a7.svg";